export default __webpack_public_path__ + "static/media/6.78905b97.jpg";